import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, forwardRef } from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
const iconStyles = {
    position: 'relative',
    display: 'inline-block',
    transition: 'transform .2s ease',
    padding: 0
};
const customStyles = (styles) => {
    const { color, width, margin = 0, rotate = 0, secondaryColor, ...restStyles } = styles;
    return {
        ...restStyles,
        color,
        margin,
        width,
        minWidth: width,
        transform: `rotate(${rotate}deg)`,
        '& .primary-color': {
            fill: color
        },
        '& .stroke-primary-color': {
            stroke: color
        },
        ...(secondaryColor
            ? {
                '& .secondary-color': {
                    fill: secondaryColor
                }
            }
            : null)
    };
};
const Icon = styled.span(({ theme }) => ({
    ...iconStyles,
    color: theme.secondaryDataColor
}), ({ styles }) => {
    if (styles) {
        return customStyles(styles);
    }
    return null;
});
const Button = styled.button(({ isDisabled, theme }) => ({
    ...iconStyles,
    pointerEvents: isDisabled ? 'none' : 'auto',
    opacity: isDisabled ? 0.5 : 1,
    color: theme.secondaryDataColor,
    transition: 'all .2s ease',
    '&:hover': {
        opacity: 0.5
    }
}), ({ styles }) => {
    if (styles) {
        return customStyles(styles);
    }
    return null;
});
const IconContainer = memo(forwardRef((props, ref) => {
    const { cy, type, onClick, children, ariaLabel, className, ariaHidden, isDisabled, ariaLabelledBy } = props;
    const { style, wrapperStyle, wrapperClassName, ...restProps } = props;
    const theme = useTheme();
    const wrapperStyles = typeof wrapperStyle === 'function' ? wrapperStyle(theme) : wrapperStyle;
    const commonProps = {
        'data-cy': cy,
        'aria-label': ariaLabel,
        'aria-hidden': ariaHidden,
        'aria-labelledby': ariaLabelledBy,
        styles: typeof style === 'function' ? style(theme) : style
    };
    function renderIcon() {
        switch (type) {
            case 'button': {
                return (_jsx(Button, { ...commonProps, ref: ref, tabIndex: 0, type: "button", onClick: onClick, disabled: isDisabled, isDisabled: isDisabled, className: `iconContainer focusableElement button ${className || ''}`, children: children }));
            }
            case 'span':
            default: {
                return (_jsx(Icon, { ...restProps, ...commonProps, className: `iconContainer ${className || ''}`, role: ariaLabel ? 'img' : 'presentation', children: children }));
            }
        }
    }
    if (wrapperStyles || wrapperClassName) {
        return (_jsx("div", { css: wrapperStyles, className: wrapperClassName, children: renderIcon() }));
    }
    return renderIcon();
}));
export default IconContainer;
//# sourceMappingURL=index.js.map